<template>
    <div class="pa-5" v-if="isUserDataLoaded">
        <div class="d-flex justify-space-between">
            <h1>{{user.firstName}} {{user.lastName}} - {{organization.name}}</h1>
            <div>
                <v-btn outlined type="button" class="mx-2" @click="goBack()"  color="warning"  dark>Go Back</v-btn>
            </div>
        </div>
        <v-tabs color="blue accent-4" background-color="transparent">
            <v-tab :to="{path:'/user/'+$route.params.userId}">
                User Profile
            </v-tab>
            <v-tab :to="{path:'/user/'+$route.params.userId+'/roles'}">
                Roles
            </v-tab>
            <v-tab :to="{path:'/user/'+$route.params.userId+'/first-alert'}"
                   v-if="$permissionHolder.hasPermission('FIRST_ALERT.CONFIGURE') && hasConfiguredPermission('FIRST_ALERT')">
                First Alert
            </v-tab>
            <v-tab :to="{path:'/user/'+$route.params.userId+'/organizations'}"
                   v-if="hasConfiguredPermission('ORGANIZATION.UPDATE')">
                Organizations
            </v-tab>
        </v-tabs>
        <router-view></router-view>
    </div>
</template>

<script>
    import api from '@/api';
    import operations from "@/operations";
    export default {
        provide() {
            return {
                getProvidedUser : () => {
                    return this.user;
                },
                getProvidedUserOrg : () => {
                    return this.organization;
                }
            }
        },
        data() {
            return {
                userId : null,
                user : {},
                organization : {},
                configuredPermissions : [],
                isUserDataLoaded : false
            }
        },
        created:function() {
            this.userId = this.$route.params.userId;
            this.get();
        },
        mounted() {
            this.$root.$on('userRolesUpdated',() => {
                this.get();
            });
            this.$root.$on('userStatusUpdated',() => {
                this.get();
            });
        },
        methods : {
            get() {
                this.$root.$emit('showGlobalOverlay');
                api.user.get(this.$route.params.userId).then(user => {
                    this.user = user;
                    operations.getUserPrimaryOrganization(this.$route.params.userId).then((org) => {
                        this.organization = org;
                        this.getPermissions().then(() => {
                            this.$root.$emit('hideGlobalOverlay');
                            this.isUserDataLoaded = true;
                        });
                    });
                });
            },
            hasConfiguredPermission(perm) {
                return this.configuredPermissions.indexOf(perm) > -1;
            },
            getPermissions() {
                return new Promise((resolve,reject) => {
                    api.permission.get(this.userId).then((perms) => {
                        this.configuredPermissions = perms;
                        resolve();
                    }).catch(() => reject());
                });
            },
            loadProfile() {
                this.$router.push({'path':'/user/'+this.userId});
            },
            loadFirstAlert() {
                this.$router.push({'name':'EditUserFirstAlert'});
            },
            loadRoles() {
                this.$router.push({'name':'EditUserRoles'});
            },
            goBack() {
                this.$router.go(-1);
            }
        }
    }
</script>